import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import { paperClasses } from '@mui/material';
import { t } from 'i18next';
import { useRef } from 'react';

import OutlinedIconButton from '~components/Buttons/OutlinedIconButton';
import CheckableMenuItem from '~components/Menu/CheckableMenuItem';
import Menu, { MenuHandler } from '~components/Menu/Menu';
import { NEW_DISPATCH_TOPBAR_MENU_WIDTH_IN_PX } from '~constants/filters';

import { OrdersPresentationMode } from './constants';

const PRESENTATION_LABEL_KEYS = {
  cards: 'dispatch.dispatch_v2.card_view',
  grid: 'dispatch.dispatch_v2.grid_view',
} satisfies Record<OrdersPresentationMode, string>;

interface OrdersPresentationMenuProps {
  onChange: (presentation: OrdersPresentationMode) => void;
  presentation: OrdersPresentationMode;
}

export default function OrdersPresentationMenu({
  onChange,
  presentation,
}: OrdersPresentationMenuProps) {
  const menuHandler = useRef<MenuHandler>(null);

  return (
    <Menu
      ref={menuHandler}
      sx={{
        [`& .${paperClasses.root}`]: {
          width: `${NEW_DISPATCH_TOPBAR_MENU_WIDTH_IN_PX}px`,
        },
      }}
      menuTrigger={
        <OutlinedIconButton
          aria-label={t('dispatch.dispatch_v2.view_options')}
          size="small"
          sx={{
            '&.MuiIconButton-root': {
              borderBottomLeftRadius: 0,
              borderTopLeftRadius: 0,
            },
          }}
        >
          <ArrowDropDown sx={{ fontSize: '18px' }} />
        </OutlinedIconButton>
      }
    >
      {(Object.keys(PRESENTATION_LABEL_KEYS) as OrdersPresentationMode[]).map(
        (option) => (
          <CheckableMenuItem
            aria-checked={presentation === option}
            isChecked={presentation === option}
            key={option}
            label={t(PRESENTATION_LABEL_KEYS[option])}
            onClick={() => {
              onChange(option);
              menuHandler.current?.onClose?.();
            }}
            role="menuitemradio"
          />
        ),
      )}
    </Menu>
  );
}
